import React from 'react';
import { observer } from "mobx-react";
import { cartInstance } from 'ReactApp/Ddd/Aggregates/Cart';
import {ShowableProductCard, showableProductCardInstance} from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { AddToWishListV1 } from 'ReactApp/Components/AddToWishListV1/AddToWishListV1';
import { AddToCompareV1 } from 'ReactApp/Components/AddToCompareV1/AddToCompareV1';
import { ShareV1 } from 'ReactApp/Components/ShareV1/ShareV1';
import { BuyBtnV1 } from 'ReactApp/Components/BuyBtnV1/BuyBtnV1';
import IconV1 from 'ReactApp/Components/IconV1/IconV1';
import TooltipV1 from '../TooltipV1/TooltipV1';

type BuyBlockV1Props = {
    productCard: ShowableProductCard
}

const BuyBlockV1 = observer((props: BuyBlockV1Props) => {

    if (props.productCard.salePrice === null) {
        return <></>;
    }

    return (
        <>
            <div className="buy-block-v1" id="buy-block-wrap">
            
                <div className="buy-block-v1__buy-container">
            
                    <div className="buy-block-v1__buy-container-row">

                        <div className="buy-block-v1__column buy-block-v1__equal buy-block-v1__action-buttons">

                            <AddToWishListV1 {...{
                                productCard: showableProductCardInstance
                            }} />

                            <AddToCompareV1 {...{
                                productCard: showableProductCardInstance
                            }} />

                           <ShareV1 {...{
                               productCard: showableProductCardInstance
                           }}/>

                        </div>

                        <div className="buy-block-v1__column">

                            <BuyBtnV1 {...{
                                productCard: showableProductCardInstance
                            }} />
            
                        </div>
            
                    </div>
            
                    <a 
                        className="
                            button-v1 
                            buy-block-v1__buy-one-click
                            more__link
                            js-open-popup
                        " 
                        href="#"
                        data-popup="js-one-click-popup"
                        data-popup-config={JSON.stringify(props.productCard.buyInClickModalConfig)}
                        >
                            Купить в один клик
                    </a>

                    <div className="found-cheaper-v1">
                        <IconV1 {...{
                            svgSpriteId: 'product-wallet',
                            width: 32,
                            height: 32,
                            classes: [
                                'found-cheaper-v1__icon'
                            ]
                        }} />
                        <a 
                            href="#" 
                            className="js-open-popup" 
                            data-popup="js-found-cheaper-popup"
                            data-popup-config={JSON.stringify(props.productCard.foundCheaperModalConfig)}
                            >
                                Нашли дешевле? Снизим цену!
                        </a>

                        <TooltipV1 content="• Программа гарантии лучшей цены – это простой способ сэкономить.<br> • Если Вы нашли такой же товар дешевле в другом интернет-магазине, то мы готовы снизить стоимость.<br> • Заполните появившуюся заявку и обязательно укажите ссылку на магазин с более низкой ценой.<br> • Наши менеджеры проверят обращение и свяжутся с Вами с обратным предложением на персональную скидку.<br> • Обратите внимание, что регионы на сравниваемых сайтах обязательно должны совпадать, а сами товары быть в наличии.<br> • Мы оставляем за собой право не предоставлять скидку или делать частичное снижение прайса на своё усмотрение.<br>" />
                    </div>
            
                </div>
            
            </div>
        </>
    );

})

export default BuyBlockV1;